import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appDynamicToolbarAnchor]',
  standalone: true
})
export class DynamicToolbarAnchorDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
